// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"altd_pLNmy3fHc2QnZolA","userBadge":"sUaNRBRutKHmQdJlNtBet"};